// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { useEffect, useState } from 'react';
import { HtmlScroll } from './HtmlScroll';
export function useScrollable(ref, isActive, axis = 'xy', events = null, isScrollbarOnStartSide = false) {
    const [viewport, setViewport] = useState(null);
    useEffect(() => {
        var _a;
        if (!isActive || !ref.current) {
            setViewport(null);
            return;
        }
        const host = ref.current;
        const hasVerticalScrollbar = axis === 'y' || axis === 'xy';
        const hasHorizontalScrollbar = axis === 'x' || axis === 'xy';
        host.classList.toggle('scrollbar-start-y', isScrollbarOnStartSide && hasVerticalScrollbar);
        host.classList.toggle('scrollbar-start-x', isScrollbarOnStartSide && hasHorizontalScrollbar);
        const scrollInstance = HtmlScroll.addScroll(host, axis, events);
        const vp = (_a = scrollInstance === null || scrollInstance === void 0 ? void 0 : scrollInstance.elements().viewport) !== null && _a !== void 0 ? _a : null;
        if (vp !== null) {
            vp.tabIndex = 0;
            vp.style.backgroundColor = 'inherit';
        }
        setViewport(vp);
        return () => {
            scrollInstance === null || scrollInstance === void 0 ? void 0 : scrollInstance.destroy();
            host.classList.remove('scrollbar-start-y', 'scrollbar-start-x');
            setViewport(null);
        };
    }, [isActive, ref, axis, events, isScrollbarOnStartSide]);
    return viewport;
}
